// removed by extract-text-webpack-plugin
module.exports = {"logoBanner":"src-components----LogoBanner-module---logoBanner---1ta9j"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LogoBanner.module.css
// module id = 189
// module chunks = 114276838955818 172411548396689